const TelephoneIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1 3.44444C1 2.09442 2.09442 1 3.44444 1H7.45241C7.97849 1 8.44555 1.33664 8.61191 1.83572L10.4426 7.3277C10.6349 7.90473 10.3737 8.53538 9.82966 8.80739L7.07079 10.1868C8.41797 13.1748 10.8252 15.582 13.8132 16.9292L15.1926 14.1703C15.4646 13.6263 16.0953 13.3651 16.6723 13.5574L22.1643 15.3881C22.6634 15.5545 23 16.0215 23 16.5476V20.5556C23 21.9056 21.9056 23 20.5556 23H19.3333C9.20811 23 1 14.7919 1 4.66667V3.44444Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default TelephoneIcon; 